const useQueryParams = () => {
  const getQueryParams = (): Record<string, string> => {
    if (typeof window === 'undefined') {
      return {};
    }

    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};

    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    return params;
  };

  const getQueryParam = (key: string): string | null => {
    if (typeof window === 'undefined') {
      return null;
    }

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  };

  const setQueryParam = (key: string, value: string): void => {
    if (typeof window === 'undefined') {
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url.toString());
  };

  const removeQueryParam = (key: string): void => {
    if (typeof window === 'undefined') {
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    window.history.pushState({}, '', url.toString());
  };

  const clearQueryParams = (): void => {
    if (typeof window === 'undefined') {
      return;
    }

    const url = new URL(window.location.href);
    url.search = '';
    window.history.pushState({}, '', url.toString());
  };

  return {
    getQueryParams,
    getQueryParam,
    setQueryParam,
    removeQueryParam,
    clearQueryParams,
  };
};

export default useQueryParams;
